import { Icon, Image, MenuItem, type MenuItemProps } from '@chakra-ui/react';
import type React from 'react';

export interface MenuItemWithIconProps extends Omit<MenuItemProps, 'icon'> {
  icon?: React.ComponentType;
  iconSrc?: string;
  iconColor?: string;
}

export const MenuItemWithIcon = ({
  icon,
  iconSrc,
  iconColor,
  ...rest
}: MenuItemWithIconProps) => {
  return (
    <MenuItem
      icon={
        icon ? (
          <Icon
            as={icon}
            w={4}
            h={4}
            color={iconColor}
            style={{
              display: 'flex',
              alignItems: 'center',
              flexWrap: 'wrap',
            }}
          />
        ) : (
          <Image
            src={iconSrc}
            alt="icon"
            w={4}
            h={4}
            style={{
              display: 'flex',
              alignItems: 'center',
              flexWrap: 'wrap',
            }}
          />
        )
      }
      {...rest}
    />
  );
};
